enum PatrimonyImageTypeEnum {
    FRONTAL = 'FRONTAL',
}

export default PatrimonyImageTypeEnum;
